module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAApCAMAAABjq9sOAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABCUExURUxpcRgYGBgYGBgYGCkpKRgYGBgYGBgYGBgYGJ2dnRgYGBgYGBgYGBgYGB4eHhgYGBkZGRkZGRgYGBoaGhoaGhgYGPBMSGIAAAAVdFJOUwDqXMUGifgp1QHfR3O5HJttUKowOpPWQsUAAADBSURBVDjL7ZPJDoMwDEQdsuGEHeb/f7WGSqgYArde2lEOZN6TlUiB6JDO2o5u0iUg3RhRuBixxGcDC1lmvuaLQesA18IsVzwHTI4AchNCPvMxoGdaBeIeYdS8CvDCN4HYI1RqPuC3j00g8kBWAxr6FKjRIxwdhb3Q2QX6plC1tcQroVrLupWrDNhSK6F/1xgooYkSfU1ey9ggScPlM7Bs1anO279wKVj7IDA/COfn8SOCQS7zDLP+6Hfx5LwpY+PdCyPEFd74KgoJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scholarships/share-icon.png
// module id = 1057
// module chunks = 85